import { Component } from '@angular/core';
import { TrialLogsTableComponent } from '../trial-logs-table/trial-logs-table.component';

@Component({
    selector: 'app-trial-log-page',
    templateUrl: './trial-logs-page.component.html',
    styleUrls: ['./trial-logs-page.component.scss'],
    imports: [TrialLogsTableComponent]
})
export class TrialLogPageComponent { }
